import { Gallery } from '../../components/Gallery';

// Function that initializes all media gallery for either standard and zoom option
const gallery = () => {
  const gallery = document.getElementById('pdp-gallery');

  const galleryInstance = new Gallery({
    gallery,
    prefixClassName: 'pdp-c-gallery',
    features: {
      keydown: true,
    },
  });
  galleryInstance.setObservers();

  // Defer this block because they're not user-visible tasks
  setTimeout(() => {
    // Generate bunch of types of handlers for standard gallery
    galleryInstance.init();
  }, 0);
};

export default gallery;
